import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { Card, Collapse } from 'antd';
import { EyeInvisibleOutlined, HolderOutlined, EyeOutlined } from '@ant-design/icons';
import SToggleCollapse from './SectionCard.style';
import CustomToolTip from '../commons/customPopover';

type Props = PropsWithChildren<{
  title: string;
  showEyeIcon?: boolean;
  notClosable?: boolean;
  notDraggable?: boolean;
}>;

// Definir una interfaz para las props adicionales
interface ChildProps {
  handleCollapseToggle: () => void;
}

const SectionCard: FC<Props> = ({ title, showEyeIcon, children, notClosable, notDraggable }) => {
  const [isComponentMounted, setIsComponentMounted] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const savedState = localStorage.getItem('sectionCollapsedState');
    const stateObj = savedState ? JSON.parse(savedState) : {};
    setIsCollapsed(
      Object.prototype.hasOwnProperty.call(stateObj, title) && stateObj[title] === false,
    );
    setIsComponentMounted(true);
  }, [title]);

  useEffect(() => {
    if (isComponentMounted) {
      const savedState = localStorage.getItem('sectionCollapsedState');
      const newState = savedState ? JSON.parse(savedState) : {};
      newState[title] = !isCollapsed;
      localStorage.setItem('sectionCollapsedState', JSON.stringify(newState));
    }
  }, [isCollapsed, title]);

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { handleCollapseToggle, isCollapsed } as ChildProps);
    }
    return child;
  });

  const renderIcon = (showIcon?: boolean) => {
    if (!showIcon) {
      return isCollapsed ? (
        <CustomToolTip title='Expand' color='white' overlayInnerStyle={{ color: 'black' }}>
          <EyeInvisibleOutlined />
        </CustomToolTip>
      ) : (
        <CustomToolTip title='Collapse' color='white' overlayInnerStyle={{ color: 'black' }}>
          <EyeOutlined />
        </CustomToolTip>
      );
    }
    return isCollapsed ? <EyeOutlined /> : null;
  };

  return (
    <Card
      title={title}
      bordered={false}
      extra={
        notClosable ? null : (
          <SToggleCollapse onClick={handleCollapseToggle}>
            {renderIcon(showEyeIcon)}
          </SToggleCollapse>
        )
      }
      className={`section-card ${isCollapsed ? 'collapsed' : 'expanded'}`}
      style={{ marginBottom: '1em', border: 'none' }}
    >
      {notDraggable ? null : <HolderOutlined />}
      <Collapse activeKey={!isCollapsed ? title : undefined}>
        <Collapse.Panel header={false} key={title}>
          {childrenWithProps}
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};

export default SectionCard;
